import { processMoneyGramDeposit } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    currentState: 'PAYMENT_STEP1', // PAYMENT_STEP1 | PAYMENT_STEP2
    depositStatus: {
      loading: false,
      success: false,
      error: false,
    },
    bonusClaimed: false,
  };
};
const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
  setCurrentState(state, val) {
    state.currentState = val;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  tryDepositMoneyGram({ commit, dispatch }, { formData }) {
    commit('depositStore/setPostDepositLoading', true, { root: true });
    commit('setDepositStatus', { loading: true, success: false, error: false });
    processMoneyGramDeposit(formData).then(r => {
      commit('depositStore/setPostDepositLoading', false, { root: true });
      if (r.data.IsSuccess) {
        dispatch('player/tryGetBalance', null, { root: true });
        commit('setDepositStatus', { error: false, success: true });
        commit('setCurrentState', 'PAYMENT_STEP2');
      } else {
        commit('setDepositStatus', { error: true, success: false });
      }
      commit('setDepositStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
